import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import App from './components/App'
import { NavigationSetter } from './navigation'

// Remove once migrated to react-router v7, should be default
const routerFutureFlags = {
    v7_relativeSplatPath: true,
    v7_startTransition: true,
};

const Root = ({ store }) => (
    <Provider store={store}>
        <BrowserRouter future={routerFutureFlags}>
            <NavigationSetter />
            <App />
        </BrowserRouter>
    </Provider>
);

Root.propTypes = {
    store: PropTypes.object.isRequired,
}

export default Root
